module.exports = __webpack_public_path__ + "static/media/Anonymous-icon.b30cddc2.svg";